<template>
    <div style="position: relative;min-height: 100%;">
        <v-app-bar app
                   dark
                   clipped-left
                   style="position: fixed;"
                   hide-on-scroll
                   extended

        >

            <v-toolbar-title class="text-uppercase grey--text"

                             @click="goHome"
                             style="cursor:pointer;position:relative"
            >
                <v-img
                        style="color:white;text-shadow: 1px 1px 6px black;z-index: 17;position:relative;"

                        :src="require('../assets/logo.png')"
                        :height="24"
                        :width="80"
                        contain

                ></v-img>

            </v-toolbar-title>

            <v-toolbar-items style="z-index: 7;" class="ml-10 hidden-sm-and-down">

                <v-btn class="text-lowercase font-weight-light" router
                       :to="'/'" tile text>
                    Start
                </v-btn>

                <v-btn :to="'/donations'" class="text-lowercase font-weight-light"  text>
                    Donationer
                </v-btn>

                <v-btn :to="'/streamhotel'" class="text-lowercase font-weight-light"  text>
                    Stream Hotel
                </v-btn>
                <v-btn :to="'/spons'" class="text-lowercase font-weight-light"  text>
                    Spons
                </v-btn>
                <v-btn :to="'/events'" class="text-lowercase font-weight-light"  text>
                    Events
                </v-btn>

                <v-btn :to="'/about'" class="text-lowercase font-weight-light"  text>
                    Om oss
                </v-btn>
            </v-toolbar-items>
            <v-spacer></v-spacer>

            <v-spacer></v-spacer>
            <v-app-bar-nav-icon app @click="$store.state.APP.DRAWER_MENU = !$store.state.APP.DRAWER_MENU"  style="position: relative;z-index: 8;"  class="justify-center" v-if="$vuetify.breakpoint.smAndDown && $store.getters.loggedIn"></v-app-bar-nav-icon>

            <v-btn app style="z-index: 8;" v-if="!$store.getters.loggedIn" @click="$store.state.APP.SHOW_LOGIN=true" text >
                <span style="">Logga in</span>
                <v-icon style="" right>mdi-login</v-icon>
            </v-btn>
            <template v-slot:extension >
                <div style="display:contents;width:100%;background: rgba(0,0,0,0.1);margin-bottom: -16px;">


                    <v-menu  v-if="$vuetify.breakpoint.mdAndDown"
                             bottom>

                        <template v-slot:activator="{ on }">
                            <v-btn
                                    style="margin-left: 14px;"

                                    class="mx-8"

                                    text
                                    icon
                                    x-small
                                    v-on="on"
                            >
                                <span>Visa:&nbsp;</span>
                                {{typeShow}}
                            </v-btn>
                        </template>

                        <v-list>
                            <v-subheader >Visa:</v-subheader>
                            <v-list-item
                                    v-for="(item, i) in showOptions"
                                    :key="i"
                                    @click="showOnly(item.title)"
                                    :id="'showSmall'+item.title"


                            >
                                <v-list-item-title>{{ item.title }}</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                    <v-btn-toggle
                            style="margin-left: 14px;"

                            group
                            mandatory
                            v-if="$vuetify.breakpoint.lgAndUp"

                    >
                        <v-btn v-for="(item, i) in showOptions"
                               :key="i"
                               @click="showOnly(item.title)"
                               small text
                               :id="'show'+item.title"


                        >
                            {{ item.title }}
                        </v-btn>
                    </v-btn-toggle>
                    <v-spacer></v-spacer>

                    <v-menu  bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn
                                    class="mx-8"
                                    icon
                                    v-on="on"
                                    style="font-size: 0.75rem;"

                                    :xSmall="!$vuetify.breakpoint.lgAndUp"
                            >
                                <v-icon>mdi-sort-descending </v-icon>
                                {{sortBy}}
                            </v-btn>
                        </template>

                        <v-list>
                            <v-subheader>Sortera efter:</v-subheader>
                            <v-list-item
                                    v-for="(item, i) in sortOptions"
                                    :key="i"
                                    @click="sortBy=item.title"
                                    style="font-size: 0.75rem;"
                            >
                                <v-list-item-title>{{ item.title }}</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                    <v-text-field
                            hide-details
                            prepend-icon="search"
                            single-line
                            clearable
                            v-model="filter"
                            style="max-width:25%;min-width:300px;margin-right:100px;"
                    ></v-text-field>


                </div>

            </template>

        </v-app-bar >


        <div  style="">
            <v-img
                    :src="user_image"
                    style="width:100%;height:420px;position: absolute;"
            >           <div class="fill-height bottom-gradient"></div>
            </v-img>
            <v-row style="width:100%;">

                <v-col cols="12">

                    <v-list dark style="background:transparent;text-align: center;">
                        <v-list-item style="top: 30px !important;" one-line>
                            <v-list-item-content>

                                <v-list-item-title style="font-family: 'Teko', sans-serif !important;" class="display-2">{{namel}} samling</v-list-item-title>
                            </v-list-item-content>

                        </v-list-item>
                    </v-list>




                </v-col>

            </v-row>
            <HicardsStats ref="hicards_stats"></HicardsStats>


            <div  style="height: calc(100% - 420px);background-image: url(/api/images/leather.png);  z-index: 0; background-size: auto; background-repeat: round; width: 100%; position: absolute;    box-shadow: inset 0px 80px 66px -20px rgba(0,0,0,0.75);"
            >
                <div style="height:60px;background:transparent;width:100%;top:0;display:inline-flex;">
                    <v-spacer></v-spacer>
                    <v-btn tile @click="createTrade" v-show="$store.state.STREAMER.SID.toString()!==sid && sid!==null"  dark class="ma-2" >
                        <v-icon left>mdi-plus</v-icon> Bytesförslag
                    </v-btn>
                    <v-spacer></v-spacer>

                </div>

            </div>



            <CardPage
                    style="padding-top:100px;"
                    v-on:actionClicked="actionClicked"
                    v-on:collectionClicked="collectionClicked"
                    v-on:sbClicked="sbClicked"
                    v-on:packClicked="packClicked"

                    :data=data
                    v-if="data.length>0"
            ></CardPage>
            <v-card
                    class="mx-auto"
                    max-width="344"
                    style="top:100px;"
                    v-if="data.length===0 && loaded"
                    dark
            >
                <v-card-text>
                    <div>Hicards</div>
                    <p class="display-1 text--primary">
                        Här var det tomt 🔍
                    </p>

                </v-card-text>

            </v-card>

        </div>




        <CollectioncardHolder
                v-on:goLeft="goLeft"
                v-on:goRight="goRight"

                :show_arrows=true
                :show=collection_show
                :card_data=collection_card_selected
                v-on:hide="collection_show=false"


        ></CollectioncardHolder>
        <SBCardHolder
                v-on:goLeft="goLeft"
                v-on:goRight="goRight"

                :show_arrows=true
                :show=sb_show
                :card_data=sb_card_selected
                v-on:hide="sb_show=false"


        ></SBCardHolder>
        <ActioncardHolder

                v-on:goLeft="goLeft"
                v-on:goRight="goRight"
                v-if="action_show"
                :show=action_show
                :card_data=action_card_selected
                v-on:hide="action_show=false"
                v-on:done="get_action_cards"


        ></ActioncardHolder>
        <PackHolder
                v-on:goLeft="goLeft"
                v-on:goRight="goRight"
                v-on:done="packDone"
                :show=pack_show
                :pack_data=pack_selected

                v-on:hide="pack_show=false"

        ></PackHolder>

        <TradeDialog :name="name" :namel="namel" :trade_dialog="trade_dialog" v-on:close="trade_dialog=false">

        </TradeDialog>
    </div>
</template>

<script>
    import CardPage from '../components/CardPage'
    import CollectioncardHolder from '../components/CollectioncardHolder'
    import ActioncardHolder from '../components/ActioncardHolder'
    import PackHolder from '../components/PackHolder'
    import HicardsStats from "../components/HicardsStats";
    import TradeDialog from "../components/TradeDialog";
    import SBCardHolder from "../components/SBCardHolder";

    export default {
        components: {SBCardHolder, HicardsStats, CardPage,CollectioncardHolder,ActioncardHolder, PackHolder,TradeDialog},
        name: "Inventory",
        data(){
            return{
                bar_heading_out:false,
                index:1,
                data:[],
                data_all_action:[],
                data_all_collection:[],
                data_all_packs:[],
                data_all_sb:[],
                data_unfiltered:[],
                action_card_selected:null,
                action_show:false,
                collection_card_selected:null,
                collection_show:false,
                sb_show:false,
                sb_card_selected:null,
                pack_selected:null,
                pack_show:false,
                page:1,
                numPage2:8,
                windowWidth: window.innerWidth,
                loaded:false,
                namel:"",
                name:"",
                user_image:"",
                sortOptions:[
                    {title:"Nyast",value:"date"},
                    {title:"Dekor",value:"tier"},
                    {title:"Namn",value:"name"},
                    {title:"Float",value:"float"},
                    {title:"Streamer",value:"streamer"}
                ],
                sortBy:"Namn",
                typeShow:"Alla",
                showOptions:[
                    {title:"Alla"},
                    {title:"Action"},
                    {title:"Collection"},
                    {title:"Packs"},
                    {title:"Streambuilder"}
                ],
                filter:"",
                selected_card_index:null,
                sid:null,
                trade_dialog:false

            }
        },
        methods:{

            createTrade:function(){
                if(!this.$store.getters.loggedIn){
                    this.$store.state.APP.SHOW_LOGIN=true;
                }
                else{
                    this.trade_dialog=true;
                }
            },

            onIntersect (entries) {
                // More information about these options
                // is located here: https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
                this.bar_heading_out= !entries[0].isIntersecting
            },
            packDone:function(){
              this.get_collection_cards();
              this.get_action_cards();
              this.get_packs();
              this.$refs.hicards_stats.get_user_data();
              this.$refs.hicards_stats.get_card_stats();

            },
            goHome:function(){
                this.$router.push({ path: '/' })
            },

            goLeft:function(){
                let next_index=this.selected_card_index-1;
                if(next_index>=0){
                    if(this.data[next_index].TYPE===0){
                        this.action_show=false;
                        this.pack_show=false;

                        this.collection_show=true;
                        this.collection_card_selected=this.data[next_index]
                        this.selected_card_index=next_index;

                    }
                    else if(this.data[next_index].TYPE===1){
                        this.collection_show=false;
                        this.pack_show=false;
                        this.action_show=true;
                        this.action_card_selected=this.data[next_index]
                        this.selected_card_index=next_index;


                    }
                    else if(this.data[next_index].TYPE===2){
                        this.collection_show=false;
                        this.action_show=false;
                        this.pack_show=true;
                        this.pack_selected=this.data[next_index];
                        this.selected_card_index=next_index;


                    }
                }

            },
            goRight:function(){
                let next_index=this.selected_card_index+1;
                if(next_index<this.data.length){
                    if(this.data[next_index].TYPE===0){
                        this.action_show=false;
                        this.pack_show=false;
                        this.collection_show=true;
                        this.collection_card_selected=this.data[next_index]
                        this.selected_card_index=next_index;


                    }
                    else if(this.data[next_index].TYPE===1){
                        this.collection_show=false;
                        this.pack_show=false;
                        this.action_show=true;
                        this.action_card_selected=this.data[next_index]
                        this.selected_card_index=next_index;


                    }
                    else if(this.data[next_index].TYPE===2){
                        this.collection_show=false;
                        this.action_show=false;
                        this.pack_show=true;
                        this.pack_selected=this.data[next_index];
                        this.selected_card_index=next_index;


                    }
                }

            },

            actionClicked:function(payload,index){
              this.action_card_selected=payload;
              this.action_show=true;
              this.selected_card_index=index;
            },
            collectionClicked:function(payload,index){

                this.collection_card_selected=payload;
                this.collection_show=true;
                this.selected_card_index=index;

            },
            sbClicked:function(payload,index){

                this.sb_card_selected=payload;
                this.sb_show=true;
                this.selected_card_index=index;

            },
            packClicked:function(payload,index){

                this.pack_selected=payload;
                this.pack_show=true;
                this.selected_card_index=index;

            },


            onResize:function(){
                if(document.body.clientWidth<960){
                    this.perPage=4;
                }
                else{
                    this.perPage=8;

                }
            },
            showOnly:function(title){
                this.typeShow=title;
                if(title==="Action"){
                    this.data_unfiltered=this.data_all_action;
                }
                else if(title==="Collection"){
                    this.data_unfiltered=this.data_all_collection;
                }

                else if(title==="Alla"){
                    this.data_unfiltered=this.data_all_sb.concat(this.data_all_packs.concat(this.data_all_collection.concat(this.data_all_action)));
                }
                else if(title==="Packs"){
                    this.data_unfiltered=this.data_all_packs;
                }
                else if(title==="Streambuilder"){
                    this.data_unfiltered=this.data_all_sb;
                }
                this.filterFunc(this.filter,"")
            },
            filterFunc:function(newVal,oldVal){

                if(newVal==="" || newVal===null){
                    this.data=this.data_unfiltered;
                }
                else if(oldVal.includes(newVal) && newVal.length>oldVal.length){

                    let searchParams=newVal.split(" ");
                    let sorted=this.data;
                    for(let i=0;i<searchParams.length;i++){
                        sorted = sorted.filter(card => card.USER_NAME.toLowerCase().includes(searchParams[i].toLowerCase()) || card.NAME.toLowerCase().includes(searchParams[i].toLowerCase()))
                    }
                    this.data=sorted;
                }
                else{

                    let searchParams=newVal.split(" ");
                    let sorted=this.data_unfiltered;
                    for(let i=0;i<searchParams.length;i++){
                        sorted = sorted.filter(card => card.USER_NAME.toLowerCase().includes(searchParams[i].toLowerCase()) || card.NAME.toLowerCase().includes(searchParams[i].toLowerCase()))
                    }
                    this.data=sorted;

                }
            },
            get_collection_cards(){
                let http = new XMLHttpRequest();
                http.withCredentials = true;
                let id=window.location.pathname.substring(11);
                this.sid=id;
                let url = '/api/get_cards?id='+id;
                http.open('GET', url, true);

                http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                let self=this;
                http.onreadystatechange = function() {

                    if(http.readyState === 4 && http.status === 403) {

                        self.$store.commit("update_snackbar","Ett fel inträffade");

                    }
                    else if(http.readyState === 4 && http.status === 200){
                        self.loaded=true;
                        if(http.responseText!=="no data"){
                            let data = JSON.parse(http.response);
                            if(data.length>0 && self.is_me){
                                if(!self.$cookies.isKey("latest_hicard")){
                                    self.$cookies.set("latest_hicard",data[0].DATE_ACQUIRED)
                                }
                                let latest=Date.parse(self.$cookies.get("latest_hicard"));
                                let didChange=false;
                                for(let i=0;i<data.length;i++){
                                    let dt=Date.parse(data[i].DATE_ACQUIRED);
                                    let offset=new Date().getTimezoneOffset();

                                    let freshness=Date.now()-dt+ (offset*60*1000);

                                    if(latest<dt){
                                        data[i].NEW=true;
                                        self.num_new+=1;

                                        didChange=true;
                                    }
                                    else if(freshness<300*1000){
                                        data[i].NEW=true;
                                        self.num_new+=1;

                                    }
                                    else{
                                        break
                                    }
                                }
                                if(didChange){
                                    self.$cookies.set("latest_hicard",data[0].DATE_ACQUIRED);

                                }
                            }



                            self.data_all_collection=data;
                            self.data=self.data_all_sb.concat(self.data_all_action.concat(self.data_all_collection.concat(self.data_all_packs)));
                            self.data_unfiltered=self.data_all_sb.concat(self.data_all_action.concat(self.data_all_collection.concat(self.data_all_packs)));
                        }

                    }

                };
                http.send();
            },
            get_action_cards(){
                let http = new XMLHttpRequest();
                http.withCredentials = true;
                let id=window.location.pathname.substring(11);
                let url = '/api/get_activity_cards?id='+id;
                http.open('GET', url, true);

                http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                let self=this;
                http.onreadystatechange = function() {

                    if(http.readyState === 4 && http.status === 403) {

                        self.$store.commit("update_snackbar","Ett fel inträffade");

                    }
                    else if(http.readyState === 4 && http.status === 200){
                        if(http.responseText!=="no data"){
                            let data = JSON.parse(http.response);
                            for (let i = 0; i < data.length; i++) {
                                if (data[i].VIDEO === null) {
                                    data[i].VIDEO = {
                                        "url": null,
                                        "video_id": null,
                                        "volume": 100,
                                        "opacity": 100,
                                        "start": 0,
                                        "end": 10

                                    }
                                } else {
                                    try {
                                        data[i].VIDEO = JSON.parse(data[i].VIDEO);
                                        data[i].VIDEO.url = "https://www.youtube.com/watch?v=" + data[i].VIDEO.video_id;

                                    } catch (e) {
                                        data[i].VIDEO = {
                                            "url": null,
                                            "video_id": null,
                                            "volume": 100,
                                            "opacity": 100,
                                            "start": 0,
                                            "end": 10

                                        }
                                    }
                                }
                            }

                            self.data_all_action=data;
                            self.data=self.data_all_sb.concat(self.data_all_action.concat(self.data_all_collection.concat(self.data_all_packs)));
                            self.data_unfiltered=self.data_all_sb.concat(self.data_all_action.concat(self.data_all_collection.concat(self.data_all_packs)));
                        }

                    }

                };
                http.send();
            },
            get_sb_cards(){
                let http = new XMLHttpRequest();
                http.withCredentials = true;
                let id=window.location.pathname.substring(11);
                this.sid=id;
                let url = '/api/get_sb_cards?id='+id;
                http.open('GET', url, true);

                http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                let self=this;
                http.onreadystatechange = function() {

                    if(http.readyState === 4 && http.status === 403) {

                        self.$store.commit("update_snackbar","Ett fel inträffade");

                    }
                    else if(http.readyState === 4 && http.status === 200){
                        self.loaded=true;
                        if(http.responseText!=="no data"){
                            let data = JSON.parse(http.response);
                            if(data.length>0 && self.is_me){
                                if(!self.$cookies.isKey("latest_hicard")){
                                    self.$cookies.set("latest_hicard",data[0].DATE_ACQUIRED)
                                }
                                let latest=Date.parse(self.$cookies.get("latest_hicard"));
                                let didChange=false;
                                for(let i=0;i<data.length;i++){
                                    let dt=Date.parse(data[i].DATE_ACQUIRED);
                                    let offset=new Date().getTimezoneOffset();

                                    let freshness=Date.now()-dt+ (offset*60*1000);

                                    if(latest<dt){
                                        data[i].NEW=true;
                                        self.num_new+=1;

                                        didChange=true;
                                    }
                                    else if(freshness<300*1000){
                                        data[i].NEW=true;
                                        self.num_new+=1;

                                    }
                                    else{
                                        break
                                    }
                                }
                                if(didChange){
                                    self.$cookies.set("latest_hicard",data[0].DATE_ACQUIRED);

                                }
                            }



                            self.data_all_sb=data;
                            self.data=self.data_all_sb.concat(self.data_all_action.concat(self.data_all_collection.concat(self.data_all_packs)));
                            self.data_unfiltered=self.data_all_sb.concat(self.data_all_action.concat(self.data_all_collection.concat(self.data_all_packs)));
                        }

                    }

                };
                http.send();
            },
            get_packs(){
                let http = new XMLHttpRequest();
                http.withCredentials = true;
                let id=window.location.pathname.substring(11);
                let url = '/api/get_packs?id='+id;
                http.open('GET', url, true);
                let self=this;
                http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

                http.onreadystatechange = function() {

                    if(http.readyState === 4 && http.status === 403) {

                        self.$store.commit("update_snackbar","Ett fel inträffade");

                    }
                    else if(http.readyState === 4 && http.status === 200){
                        if(http.responseText!=="no data"){
                            let data = JSON.parse(http.response);

                            self.data_all_packs=data;
                            self.data=self.data_all_action.concat(self.data_all_collection.concat(self.data_all_packs));
                            self.data_unfiltered=self.data_all_action.concat(self.data_all_collection.concat(self.data_all_packs));
                        }

                    }

                };
                http.send();
            },
            get_user_name:function(){
                let http = new XMLHttpRequest();
                http.withCredentials = true;
                let id = window.location.pathname.substring(11);
                let url = '/api/get_user_from_id?id='+id;
                http.open('GET', url, true);
                let self=this;
                http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

                http.onreadystatechange = function() {

                    if(http.readyState === 4 && http.status === 403) {

                        self.$store.commit("update_snackbar","Ett fel inträffade");

                    }
                    else if(http.readyState === 4 && http.status === 200){
                        if(http.responseText!=="no data"){
                            self.namel=http.response;
                            self.name=http.response;
                            if(self.namel.slice(-1)!=="s" && self.namel.slice(-1)!=="S" && self.namel.slice(-1)!=="x" && self.namel.slice(-1)!=="X"){
                                self.namel+="s"
                            }
                            let testimage= new Image();
                            let id = window.location.pathname.substring(11);
                            testimage.onload = function() {
                                self.user_image=testimage.src
                            }
                            testimage.onerror = function() {
                                self.user_image=`/api/avatar/${http.response.toUpperCase()}`

                            }
                            testimage.src="/api/images/users/"+id+".png";
                        }



                    }

                };
                http.send();
            }


        },
        computed:{

            is_me:function(){

                return this.$store.state.STREAMER.SID.toString()===this.sid.toString();
            }

        },
        watch:{
            trade_dialog:  {
                immediate: true,
                handler(val) {
                    document.querySelector('html').style.overflow = val ? 'hidden' : null
                }
            },
            sid:function(){
                let self=this;
                setTimeout(function(){

                    if(self.sid.toString()===self.$store.state.STREAMER.SID.toString() &&  self.$store.state.APP.NEW_CARDS>0){
                        console.log("CLEARING");
                        self.$store.dispatch("reset_num_cards");

                    }
                },2000);



            },


            $route(to, from) { // react to route changes...
                 if(to !== from){

                     this.get_action_cards();
                     this.get_collection_cards();
                     this.get_sb_cards();
                     this.get_packs();
                     this.get_user_name();
                 }
            },


            filter:function(newVal,oldVal){
                this.filterFunc(newVal,oldVal)
            },
            sortBy:function(newVal){
                if(newVal==="Namn"){
                    this.data.sort(function(a, b){
                        var nameA=a.NAME.toLowerCase(), nameB=b.NAME.toLowerCase();
                        if (nameA < nameB)
                            return -1;
                        if (nameA > nameB)
                            return 1;
                        return 0;
                    });
                }
                else if(newVal==="Streamer"){
                    this.data.sort(function(a, b){
                        var nameA=a.USER_NAME.toLowerCase(), nameB=b.USER_NAME.toLowerCase();
                        if (nameA < nameB)
                            return -1;
                        if (nameA > nameB)
                            return 1;
                        return 0;
                    });
                }
                else if(newVal==="Dekor"){
                    this.data.sort(function(a, b){
                        var rankA,rankB;
                        if(a.TYPE===0){
                            rankA=a.RANK_VALUE;
                        }
                        else if(a.TYPE===1){
                            rankA=a.RANK;
                        }
                        else{
                            rankA=0
                        }
                        if(b.TYPE===0){
                            rankB=b.RANK_VALUE;
                        }
                        else if(b.TYPE===1){
                            rankB=b.RANK;
                        }
                        else{
                            rankB=0
                        }

                        if (rankA > rankB)
                            return -1;
                        if (rankA < rankB)
                            return 1;
                        return 0;
                    });
                }
                else if(newVal==="Float"){
                    this.data.sort(function(a, b){
                        var floatA,floatB;
                        if(a.TYPE===0){
                            floatA=(Math.sqrt((a.FLOAT_X*a.FLOAT_X)+(a.FLOAT_Y*a.FLOAT_Y))/Math.sqrt(2));
                        }
                        else{
                            floatA=1
                        }
                        if(b.TYPE===0){
                            floatB=(Math.sqrt((b.FLOAT_X*b.FLOAT_X)+(b.FLOAT_Y*b.FLOAT_Y))/Math.sqrt(2));
                        }
                        else{
                            floatB=1
                        }



                        if (floatA < floatB)
                            return -1;
                        if (floatA > floatB)
                            return 1;
                        return 0;
                    });
                }
                else if(newVal==="Nyast"){
                    this.data.sort(function(a, b){
                        var dateA = new Date(a.DATE_REG);
                        var dateB = new Date(b.DATE_REG);



                        if (dateA.getTime() < dateB.getTime())
                            return 1;
                        if (dateA.getTime() > dateB.getTime())
                            return -1;
                        return 0;
                    });
                }

            }
        },
        mounted() {
            this.get_action_cards();
            this.get_collection_cards();
            this.get_packs();
            this.get_sb_cards();
            this.get_user_name();

            window.addEventListener('resize', () => {
                this.windowWidth = window.innerWidth;
            })


            if(this.$route.query.f==="a"){
                if(this.$vuetify.breakpoint.mdAndUp){
                    setTimeout(function(){
                        document.getElementById("showAction").click();
                    },500);
                }
                else{
                    setTimeout(function(){
                        document.getElementById("showActionSmall").click();
                    },500);
                }

            }
            else if(this.$route.query.f==="c"){
                if(this.$vuetify.breakpoint.mdAndUp){
                    setTimeout(function(){
                        document.getElementById("showCollection").click();
                    },500);
                }
                else{
                    setTimeout(function(){
                        document.getElementById("showCollectionSmall").click();
                    },500);
                }

            }
            else if(this.$route.query.f==="p"){
                if(this.$vuetify.breakpoint.mdAndUp){
                    setTimeout(function(){
                        document.getElementById("showPacks").click();
                    },500);
                }
                else{
                    setTimeout(function(){
                        document.getElementById("showPacksSmall").click();
                    },500);
                }

            }

            if(this.$route.query.search){
                let self=this;
                setTimeout(function(){
                    self.filter=self.$route.query.search;

                },500);

            }

        }
    }
</script>

<style>
    .v-dialog--fullscreen {
        border-radius: 0;
        margin: 0;
        height: 100%;
        position: fixed;
        overflow:hidden !important;
        left: 0;
    }

    .v-toolbar__extension{
        padding-left:0 !important;
        padding-right:0 !important;
    }

    .bottom-gradient {
        background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0.2) 100%);
    }




</style>
